<template>
    <div class="mt-4 space-y-4">
        <experience-switch-panel @changed="refresh" />
        <offer-experience-lookup ref="lookup" @changed="refresh" />
        <experience-rules-table kind="producer" :refresh-key="refreshKey" />
        <experience-rules-table kind="offer" :refresh-key="refreshKey" />
        <experience-changes-table :refresh-key="refreshKey" />
    </div>
</template>

<script>
import ExperienceChangesTable from "../../components/config/checkout-experience/ExperienceChangesTable.vue";
import ExperienceRulesTable from "../../components/config/checkout-experience/ExperienceRulesTable.vue";
import ExperienceSwitchPanel from "../../components/config/checkout-experience/ExperienceSwitchPanel.vue";
import OfferExperienceLookup from "../../components/config/checkout-experience/OfferExperienceLookup.vue";

export default {
    name: "CheckoutExperience",

    components: {
        ExperienceChangesTable,
        ExperienceRulesTable,
        ExperienceSwitchPanel,
        OfferExperienceLookup,
    },

    data() {
        return {
            refreshKey: 0,
        };
    },

    methods: {
        // Qualquer mudança gravada recarrega listas, histórico e a consulta aberta.
        refresh() {
            this.refreshKey += 1;
            this.$refs.lookup?.refresh();
        },
    },
};
</script>
